var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhitepaperIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/document-text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/document-text_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M14 4.66732V11.334C14 13.334 13 14.6673 10.6667 14.6673H5.33333C3 14.6673 2 13.334 2 11.334V4.66732C2 2.66732 3 1.33398 5.33333 1.33398H10.6667C13 1.33398 14 2.66732 14 4.66732Z",
    fill: "#85D1F0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.3337 6.16667H11.0003C9.98699 6.16667 9.16699 5.34667 9.16699 4.33333V3C9.16699 2.72667 9.39366 2.5 9.66699 2.5C9.94033 2.5 10.167 2.72667 10.167 3V4.33333C10.167 4.79333 10.5403 5.16667 11.0003 5.16667H12.3337C12.607 5.16667 12.8337 5.39333 12.8337 5.66667C12.8337 5.94 12.607 6.16667 12.3337 6.16667Z",
    fill: "#85D1F0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.99967 9.16602H5.33301C5.05967 9.16602 4.83301 8.93935 4.83301 8.66602C4.83301 8.39268 5.05967 8.16602 5.33301 8.16602H7.99967C8.27301 8.16602 8.49967 8.39268 8.49967 8.66602C8.49967 8.93935 8.27301 9.16602 7.99967 9.16602Z",
    fill: "#85D1F0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.6663 11.834H5.33301C5.05967 11.834 4.83301 11.6073 4.83301 11.334C4.83301 11.0607 5.05967 10.834 5.33301 10.834H10.6663C10.9397 10.834 11.1663 11.0607 11.1663 11.334C11.1663 11.6073 10.9397 11.834 10.6663 11.834Z",
    fill: "#85D1F0"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitepaperIcon);
export default __webpack_public_path__ + "static/media/whitepaper-icon.1eb2edcfc14b6591984c5a89b2a20668.svg";
export { ForwardRef as ReactComponent };